import { generalActions } from './generalActions';
import { formActions } from './formActions';
import { authActions } from './authActions';
import { registrationActions } from './registrationActions';
import { paymentActions } from './paymentActions';

export const useActions = (state, dispatch) => {
  return {
    generalActions: generalActions({ state, dispatch }),
    formActions: formActions({ state, dispatch }),
    registrationActions: registrationActions({ state, dispatch }),
    authActions: authActions({ state, dispatch }),
    paymentActions: paymentActions({ state, dispatch }),
  }
};